import { useState, useRef, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import { ChevronDown, Lock, MapPin, Hotel, ArrowRight, X, Menu, LogOut, Save, Edit, Trash2, Download, Mail, Users, Play, ArrowLeft, Headphones, Share2, MessageCircle, Star, Globe, Heart } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// NEW Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_f869070e-5310-4fe2-9a2e-bf23f13a0f77/artifacts/r2bmq0u5_SP%20Logo%20.png";

// Content data for Netflix-style rails - ULTRA SEXY representative images
const contentSections = [
{
  id: "top10",
  title: "Top 10",
  subtitle: "This Week",
  showNumbers: true,
  items: [
  { id: 1, title: "Amangiri", location: "Utah, USA", tags: ["Desert", "Wellness"], image: "https://images.unsplash.com/photo-1709380526836-100c551cfc28?w=600&q=80", hasPreview: true },
  { id: 2, title: "Six Senses Ibiza", location: "Ibiza, Spain", tags: ["Beach", "Bohemian"], image: "https://images.unsplash.com/photo-1602212356541-b9b31ea96a42?w=600&q=80" },
  { id: 3, title: "Como Shambhala", location: "Ubud, Bali", tags: ["Jungle", "Spiritual"], image: "https://images.unsplash.com/photo-1567491634123-460945ea86dd?w=600&q=80" },
  { id: 4, title: "Kamalaya Koh Samui", location: "Thailand", tags: ["Wellness", "Beach"], image: "https://images.unsplash.com/photo-1729720281656-0ee786260bde?w=600&q=80" },
  { id: 5, title: "SHA Wellness Clinic", location: "Alicante, Spain", tags: ["Medical", "Longevity"], image: "https://images.unsplash.com/photo-1692651762918-5c96f87c5448?w=600&q=80" },
  { id: 6, title: "Lefay Resort Dolomiti", location: "Italy", tags: ["Mountains", "Alpine"], image: "https://images.unsplash.com/photo-1747238497971-711eeccffcb3?w=600&q=80" },
  { id: 7, title: "Borgo Egnazia", location: "Puglia, Italy", tags: ["Italian", "Culture"], image: "https://images.unsplash.com/photo-1542581509-7e87190743b6?w=600&q=80" },
  { id: 8, title: "Ananda in the Himalayas", location: "Rishikesh, India", tags: ["Himalayan", "Yoga"], image: "https://images.unsplash.com/photo-1669304944449-4a1dc72cada4?w=600&q=80" }]
},
{
  id: "longevity",
  title: "Longevity",
  subtitle: "Hotels",
  items: [
  { id: 1, title: "Clinique La Prairie", location: "Montreux, Switzerland", tags: ["Medical", "Anti-Aging"], image: "https://images.unsplash.com/photo-1733950489669-d4a37d3afef7?w=600&q=80" },
  { id: 2, title: "Lanserhof Tegernsee", location: "Bavaria, Germany", tags: ["Detox", "Medical"], image: "https://images.unsplash.com/photo-1760030779306-4566278cb5dc?w=600&q=80" },
  { id: 3, title: "Buchinger Wilhelmi", location: "Lake Constance", tags: ["Fasting", "Wellness"], image: "https://images.unsplash.com/photo-1761226925839-8dab44888696?w=600&q=80" },
  { id: 4, title: "Vivamayr Altaussee", location: "Austria", tags: ["Mayr", "Detox"], image: "https://images.unsplash.com/photo-1762855331879-86daf923a2d9?w=600&q=80" },
  { id: 5, title: "The Ranch Malibu", location: "California, USA", tags: ["Fitness", "Plant-Based"], image: "https://images.unsplash.com/photo-1615570965691-70ebb9033786?w=600&q=80" },
  { id: 6, title: "Chiva-Som", location: "Hua Hin, Thailand", tags: ["Holistic", "Spa"], image: "https://images.unsplash.com/photo-1651376318405-f1055f37a511?w=600&q=80" }]
},
{
  id: "fitness",
  title: "Fitness",
  subtitle: "Hotels",
  items: [
  { id: 1, title: "Euphoria Retreat", location: "Mystras, Greece", tags: ["Holistic", "Fitness"], image: "https://images.unsplash.com/photo-1681118143199-53d8afa71b40?w=600&q=80" },
  { id: 2, title: "Cal-a-Vie Health Spa", location: "California, USA", tags: ["Weight Loss", "Fitness"], image: "https://images.unsplash.com/photo-1766955048640-cbe70146cfda?w=600&q=80" },
  { id: 3, title: "Marbella Club", location: "Spain", tags: ["Beach", "Tennis"], image: "https://images.unsplash.com/photo-1770929356942-211ef44d03be?w=600&q=80" },
  { id: 4, title: "Forte Village", location: "Sardinia, Italy", tags: ["Sports", "Family"], image: "https://images.unsplash.com/photo-1691511295701-dd380c6c91ad?w=600&q=80" },
  { id: 5, title: "Puente Romano", location: "Marbella, Spain", tags: ["Tennis", "Beach"], image: "https://images.unsplash.com/photo-1740053045126-bf4aade8e2e4?w=600&q=80" }]
},
{
  id: "restaurants",
  title: "Excellence",
  subtitle: "Restaurants",
  items: [
  { id: 1, title: "Noma", location: "Copenhagen, Denmark", tags: ["Nordic", "Innovation"], image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80" },
  { id: 2, title: "Eleven Madison Park", location: "New York, USA", tags: ["Plant-Based", "Fine Dining"], image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80" },
  { id: 3, title: "Mirazur", location: "Menton, France", tags: ["Mediterranean", "Garden"], image: "https://images.unsplash.com/photo-1759848618819-73aedf6a2337?w=600&q=80" },
  { id: 4, title: "Central", location: "Lima, Peru", tags: ["Peruvian", "Altitude"], image: "https://images.unsplash.com/photo-1714876906025-77b148689e2c?w=600&q=80" },
  { id: 5, title: "Geranium", location: "Copenhagen, Denmark", tags: ["Nordic", "Seasonal"], image: "https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?w=600&q=80" },
  { id: 6, title: "Disfrutar", location: "Barcelona, Spain", tags: ["Avant-Garde", "Spanish"], image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=600&q=80" }]
},
{
  id: "suedtirol",
  title: "Südtirol",
  subtitle: "& Dolomites",
  items: [
  { id: 1, title: "Forestis", location: "Brixen, Italy", tags: ["Alpine", "Retreat"], image: "https://images.unsplash.com/photo-1616327873143-758094075d4b?w=600&q=80" },
  { id: 2, title: "Adler Spa Resort", location: "Val Gardena", tags: ["Ski", "Spa"], image: "https://images.unsplash.com/photo-1667925459217-e7b7a9797409?w=600&q=80" },
  { id: 3, title: "Hotel Hubertus", location: "Olang", tags: ["Design", "Pool"], image: "https://images.unsplash.com/photo-1616327873424-14fb2798f638?w=600&q=80" },
  { id: 4, title: "Alpin Panorama Hubertus", location: "Valdaora", tags: ["Wellness", "Mountains"], image: "https://images.unsplash.com/photo-1616327873441-a9e0e6a4ca6b?w=600&q=80" },
  { id: 5, title: "Miramonti Boutique Hotel", location: "Merano", tags: ["Design", "Garden"], image: "https://images.unsplash.com/photo-1678902177251-7ec8fea483a3?w=600&q=80" }]
},
{
  id: "mountains",
  title: "Mountains",
  subtitle: "& Alps",
  items: [
  { id: 1, title: "The Alpina Gstaad", location: "Switzerland", tags: ["Luxury", "Ski"], image: "https://images.unsplash.com/photo-1757514265590-f58b0e143393?w=600&q=80" },
  { id: 2, title: "Chalet Zermatt Peak", location: "Zermatt, Switzerland", tags: ["Chalet", "Exclusive"], image: "https://images.unsplash.com/photo-1742638163698-b325181951a4?w=600&q=80" },
  { id: 3, title: "San Lorenzo Mountain Lodge", location: "Dolomites", tags: ["Boutique", "Alpine"], image: "https://images.unsplash.com/photo-1697757657493-cf2922fe24cc?w=600&q=80" },
  { id: 4, title: "Whitepod", location: "Swiss Alps", tags: ["Eco", "Unique"], image: "https://images.unsplash.com/photo-1596217188492-e7fa61ed0665?w=600&q=80" },
  { id: 5, title: "Aman Le Mélézin", location: "Courchevel, France", tags: ["Aman", "Ski"], image: "https://images.unsplash.com/photo-1710862866602-7a98e48cbab9?w=600&q=80" }]
},
{
  id: "italy",
  title: "Italy",
  subtitle: "La Dolce Vita",
  items: [
  { id: 1, title: "Belmond Hotel Caruso", location: "Ravello, Amalfi", tags: ["Coastal", "Historic"], image: "https://images.unsplash.com/photo-1690228685261-0cadc444689f?w=600&q=80" },
  { id: 2, title: "Aman Venice", location: "Venice", tags: ["Palazzo", "Iconic"], image: "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=600&q=80" },
  { id: 3, title: "Hotel Il Pellicano", location: "Tuscany Coast", tags: ["Riviera", "Classic"], image: "https://images.unsplash.com/photo-1636445609165-fbeedf1747fe?w=600&q=80" },
  { id: 4, title: "Castello di Casole", location: "Tuscany", tags: ["Estate", "Wine"], image: "https://images.unsplash.com/photo-1534246541854-7cc96531e20e?w=600&q=80" },
  { id: 5, title: "Grand Hotel Tremezzo", location: "Lake Como", tags: ["Lake", "Art Nouveau"], image: "https://images.unsplash.com/photo-1663080821866-c469deda373a?w=600&q=80" },
  { id: 6, title: "Rosewood Castiglion del Bosco", location: "Tuscany", tags: ["Wine Estate", "Golf"], image: "https://images.unsplash.com/photo-1663242825430-2980ab7c2bda?w=600&q=80" }]
}];


// Background images for hero - more visible now
const heroBackgroundImages = [
"https://images.unsplash.com/photo-1582719508461-905c673771fd?w=400&q=80",
"https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&q=80",
"https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=400&q=80",
"https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&q=80",
"https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&q=80",
"https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=400&q=80",
"https://images.unsplash.com/photo-1445019980597-93fa8acb246c?w=400&q=80",
"https://images.unsplash.com/photo-1584132967334-10e028bd69f7?w=400&q=80",
"https://images.unsplash.com/photo-1600011689032-8b628b8a8747?w=400&q=80",
"https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=400&q=80",
"https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=400&q=80",
"https://images.unsplash.com/photo-1596178065887-1198b6148b2b?w=400&q=80",
"https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=400&q=80",
"https://images.unsplash.com/photo-1615460549969-36fa19521a4f?w=400&q=80",
"https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=400&q=80",
"https://images.unsplash.com/photo-1540541338287-41700207dee6?w=400&q=80",
"https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=400&q=80",
"https://images.unsplash.com/photo-1586375300773-8384e3e4916f?w=400&q=80",
"https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=400&q=80",
"https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&q=80",
"https://images.unsplash.com/photo-1559339352-11d035aa65de?w=400&q=80",
"https://images.unsplash.com/photo-1544025162-d76694265947?w=400&q=80",
"https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&q=80",
"https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?w=400&q=80"];


// Badge levels: Selected (1), Verified (2), Prestige (3), Signature (4), Honored (5)
// HONORED is for: Aman, SHA, Lanserhof, Rosewood, Six Senses, iconic heritage hotels
const honoredBrands = ['Aman', 'SHA', 'Lanserhof', 'Rosewood', 'Six Senses', 'Belmond', 'Cheval Blanc', 'Four Seasons'];

const getBadgeLevel = (id, sectionId, hotelName = '') => {
  // Check if hotel is HONORED brand
  const isHonored = honoredBrands.some(brand => hotelName.toLowerCase().includes(brand.toLowerCase()));
  if (isHonored) {
    return { level: 5, hasAward: true, awardYears: 10 };
  }
  
  // Distribute badges based on item and section
  const combined = id + (sectionId?.charCodeAt(0) || 0);
  const level = (combined % 4) + 1;

  // Award for years of success (some hotels get it)
  const hasAward = combined % 5 === 0;
  const awardYears = hasAward ? [5, 10, 15, 20, 25][combined % 5] || 10 : 0;

  return { level, hasAward, awardYears };
};

// Badge colors - harmonized with CI (no gold for badges, reserved for CTAs)
const badgeConfig = {
  1: { name: 'Selected', icon: '○', gradient: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', textColor: '#d1d5db', borderColor: 'rgba(107, 114, 128, 0.5)' },
  2: { name: 'Verified', icon: '✓', gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', textColor: '#a7f3d0', borderColor: 'rgba(16, 185, 129, 0.5)' },
  3: { name: 'Prestige', icon: '★', gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', textColor: '#ddd6fe', borderColor: 'rgba(139, 92, 246, 0.5)' },
  4: { name: 'Signature', icon: '✦', gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', textColor: '#bfdbfe', borderColor: 'rgba(59, 130, 246, 0.5)' },
  5: { name: 'Honored', icon: '♛', gradient: 'linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)', textColor: '#fecdd3', borderColor: 'rgba(244, 63, 94, 0.5)' }
};

// Preview Card Component
const PreviewCard = ({ item, index, showNumber, sectionId, onShowPreview }) => {
  const { level, hasAward, awardYears } = getBadgeLevel(item.id, sectionId, item.title);
  const badge = badgeConfig[level];

  const handleClick = () => {
    if (item.hasPreview && onShowPreview) {
      onShowPreview(item);
    } else {
      toast("Subscribe to unlock", {
        description: "Join The Soulful Traveller to explore this destination",
        style: {
          background: '#141414',
          border: '1px solid #e3ab19',
          color: '#ffffff'
        }
      });
    }
  };

  return (
    <div
      className={`preview-card ${item.hasPreview ? 'has-preview' : ''}`}
      onClick={handleClick}
      data-testid={`preview-card-${item.id}`}>

      <img src={item.image} alt={item.title} loading="lazy" />
      <div className="card-gradient" />
      
      {/* Preview Play Button for Amangiri */}
      {item.hasPreview && (
        <div className="preview-play-btn">
          <Play size={24} fill="#ffffff" />
        </div>
      )}
      
      {/* Level Badge */}
      <div
        className="level-badge"
        style={{
          background: badge.gradient,
          borderColor: badge.borderColor,
          color: badge.textColor
        }}>

        <span className="badge-icon">{badge.icon}</span>
        <span>{badge.name}</span>
      </div>
      
      {/* Award Badge for years of success */}
      {hasAward &&
      <div className="award-badge">
          <span className="award-icon">🏆</span>
          <span>{awardYears}+ Years</span>
        </div>
      }
      
      <div className="card-content">
        {showNumber && <div className="card-number">{index + 1}</div>}
        <h3 className="card-title blurred-text-soft">{item.title}</h3>
        <div className="card-location">
          <MapPin size={12} />
          <span>{item.location}</span>
        </div>
        <div className="card-tags">
          {item.tags.map((tag, i) =>
          <span key={i} className="card-tag">{tag}</span>
          )}
        </div>
      </div>
      {!item.hasPreview && (
        <div className="lock-overlay">
          <div className="lock-badge">
            <Lock size={14} />
            <span>Subscribe</span>
          </div>
        </div>
      )}
    </div>);

};

// Content Section Component
const ContentSection = ({ section, onShowPreview }) => {
  return (
    <section className="content-section" data-testid={`section-${section.id}`}>
      <div className="section-header">
        <h2 className="section-title">
          {section.title} <span>{section.subtitle}</span>
        </h2>
      </div>
      <div className="card-rail scrollbar-hide">
        {section.items.map((item, index) =>
        <PreviewCard
          key={item.id}
          item={item}
          index={index}
          showNumber={section.showNumbers}
          sectionId={section.id}
          onShowPreview={onShowPreview} />
        )}
      </div>
    </section>);
};

// Hero Section Component - ITB Partner Application
const HeroSection = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [sameAsApplicant, setSameAsApplicant] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    partner_type: "",
    company_name: "",
    website: "",
    contact_name: "",
    contact_role: "",
    email: "",
    decision_maker_name: "",
    decision_maker_role: "",
    decision_maker_email: "",
    gdpr_consent: false,
    contact_consent: false
  });
  const contentRef = useRef(null);

  const scrollToContent = () => {
    contentRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSameAsApplicant = (checked) => {
    setSameAsApplicant(checked);
    if (checked) {
      setFormData({
        ...formData,
        decision_maker_name: formData.contact_name,
        decision_maker_role: formData.contact_role,
        decision_maker_email: formData.email
      });
    } else {
      setFormData({
        ...formData,
        decision_maker_name: "",
        decision_maker_role: "",
        decision_maker_email: ""
      });
    }
  };

  const partnerTypes = [
    "Hotel / Resort",
    "Hotel Group",
    "Destination / Tourist Board",
    "Travel Rep / PR Agency",
    "Tour Operator / DMC",
    "Airline",
    "Brand / Collaboration Partner",
    "Other"
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.gdpr_consent) {
      setError("Please accept the privacy policy");
      return;
    }
    
    if (!formData.contact_consent) {
      setError("Please accept the contact consent");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/partner-application`, formData);
      setIsSubmitted(true);
      setShowSuccessPopup(true);
      toast.success("Application submitted successfully!", {
        style: { background: '#141414', border: '1px solid #e3ab19', color: '#ffffff' }
      });
    } catch (err) {
      const errorMessage = err.response?.data?.detail || "Something went wrong";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="hero-section" data-testid="hero-section">
        {/* Background Grid */}
        <div className="hero-background">
          <div className="hero-background-grid-visible">
            {heroBackgroundImages.map((img, index) =>
            <div key={index} className="hero-bg-card-visible">
                <img src={img} alt="" loading="lazy" />
              </div>
            )}
          </div>
        </div>
        
        <div className="hero-overlay-light" />

        {/* Main Content */}
        <div className="hero-content">
          <div className="logo-container-large">
            <img
              src={LOGO_URL}
              alt="Soulful Places"
              data-testid="logo" />
          </div>

          <h1 className="hero-headline">The League of Exceptional Hotels & Destinations</h1>
          <p className="hero-netflix">This is the world's first Netflix-like Video & Podcast platform<br />for Soulful Hotels & Destinations.</p>
          <p className="hero-subheadline">A Private Curated Society for the World's<br />Most Distinctive Properties & Experiences</p>
          
          <p className="hero-features">Global Positioning • Cinematic Storytelling • Private Distribution</p>
          <p className="hero-since">Since 1985</p>
          
          <p className="hero-exclusive">By Invitation & Selection Only</p>

          {!showForm && !isSubmitted && (
            <button 
              className="cta-reveal-btn"
              onClick={() => setShowForm(true)}
              data-testid="reveal-form-btn"
            >
              REQUEST PRIVATE CONSIDERATION
            </button>
          )}

          {showForm && !isSubmitted && (
            <form className="itb-form" onSubmit={handleSubmit} data-testid="itb-form">
              
              {/* Partner Type Dropdown */}
              <div className="form-field">
                <select
                  value={formData.partner_type}
                  onChange={(e) => setFormData({ ...formData, partner_type: e.target.value })}
                  required
                  className="itb-select"
                  data-testid="partner-type"
                >
                  <option value="" disabled>What best describes you? *</option>
                  {partnerTypes.map((type) => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>

              {/* Company & Website */}
              <div className="form-row">
                <input
                  type="text"
                  placeholder="Property / Company Name *"
                  value={formData.company_name}
                  onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
                  required
                  className="itb-input"
                  data-testid="company-name"
                />
                <input
                  type="text"
                  placeholder="Website URL *"
                  value={formData.website}
                  onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                  required
                  className="itb-input"
                  data-testid="website"
                />
              </div>

              {/* Applicant Section */}
              <div className="applicant-section">
                <p className="section-label">Applicant Information</p>
                <div className="form-row">
                  <input
                    type="text"
                    placeholder="Your Full Name *"
                    value={formData.contact_name}
                    onChange={(e) => setFormData({ ...formData, contact_name: e.target.value })}
                    required
                    className="itb-input"
                    data-testid="contact-name"
                  />
                  <input
                    type="text"
                    placeholder="Your Role / Position *"
                    value={formData.contact_role}
                    onChange={(e) => setFormData({ ...formData, contact_role: e.target.value })}
                    required
                    className="itb-input"
                    data-testid="contact-role"
                  />
                </div>
                <input
                  type="email"
                  placeholder="Your Email *"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="itb-input"
                  data-testid="contact-email"
                />
              </div>

              {/* Decision Maker Section */}
              <div className="decision-maker-section">
                <p className="dm-label">Decision Maker for investments in partnerships and/or marketing *</p>
                <p className="dm-subtitle">Person responsible for investment decisions in partnerships, marketing or visibility</p>
                
                <div className="same-as-applicant">
                  <input
                    type="checkbox"
                    id="same-applicant"
                    checked={sameAsApplicant}
                    onChange={(e) => handleSameAsApplicant(e.target.checked)}
                    className="gdpr-checkbox"
                  />
                  <label htmlFor="same-applicant" className="same-label">Same as applicant</label>
                </div>

                <div className="form-row">
                  <input
                    type="text"
                    placeholder="Decision Maker Name *"
                    value={formData.decision_maker_name}
                    onChange={(e) => setFormData({ ...formData, decision_maker_name: e.target.value })}
                    required
                    disabled={sameAsApplicant}
                    className={`itb-input ${sameAsApplicant ? 'input-disabled' : ''}`}
                    data-testid="dm-name"
                  />
                  <input
                    type="text"
                    placeholder="Decision Maker Role *"
                    value={formData.decision_maker_role}
                    onChange={(e) => setFormData({ ...formData, decision_maker_role: e.target.value })}
                    required
                    disabled={sameAsApplicant}
                    className={`itb-input ${sameAsApplicant ? 'input-disabled' : ''}`}
                    data-testid="dm-role"
                  />
                </div>
                <input
                  type="email"
                  placeholder="Decision Maker Email *"
                  value={formData.decision_maker_email}
                  onChange={(e) => setFormData({ ...formData, decision_maker_email: e.target.value })}
                  required
                  disabled={sameAsApplicant}
                  className={`itb-input ${sameAsApplicant ? 'input-disabled' : ''}`}
                  data-testid="dm-email"
                />
              </div>

              {/* Consent Checkboxes */}
              <div className="consent-section">
                {/* Privacy Policy */}
                <div className="consent-row">
                  <input
                    type="checkbox"
                    className="consent-checkbox"
                    checked={formData.gdpr_consent}
                    onChange={(e) => setFormData({ ...formData, gdpr_consent: e.target.checked })}
                    id="gdpr-itb"
                    data-testid="gdpr-check"
                  />
                  <label htmlFor="gdpr-itb" className="consent-label">
                    I agree to the <Link to="/datenschutz" className="consent-link">Privacy Policy</Link>
                  </label>
                </div>

                {/* Contact Consent with Tooltip */}
                <div className="consent-row consent-with-tooltip">
                  <input
                    type="checkbox"
                    className="consent-checkbox"
                    checked={formData.contact_consent}
                    onChange={(e) => setFormData({ ...formData, contact_consent: e.target.checked })}
                    id="contact-consent"
                    data-testid="contact-consent-check"
                  />
                  <label htmlFor="contact-consent" className="consent-label">
                    I agree to be contacted regarding partnership evaluation
                    <span className="tooltip-icon">?</span>
                    <span className="consent-tooltip">
                      I consent to being contacted by Soulful Places and its partnership team regarding my application, partnership opportunities and related communication. If I provide contact details of colleagues or decision makers, I confirm that they are aware of this request and may be contacted in relation to this application.
                    </span>
                  </label>
                </div>
              </div>

              {error && <p className="error-message">{error}</p>}

              {/* Submit Button */}
              <button
                type="submit"
                className="itb-submit-btn btn-luxury"
                disabled={isLoading}
                data-testid="submit-btn"
              >
                {isLoading ? <div className="spinner" /> : "SUBMIT APPLICATION"}
              </button>
              
              <p className="submit-note">Selected partners will be invited personally.</p>
            </form>
          )}

          {isSubmitted && !showSuccessPopup && (
            <div className="success-message" data-testid="success-message">
              <p>Thank you for your consideration request.</p>
              <p style={{ fontSize: '0.875rem', marginTop: '8px', color: '#a3a3a3' }}>
                Our selection committee will review your submission and respond personally.
              </p>
            </div>
          )}

          {/* Success Popup Modal */}
          {showSuccessPopup && (
            <>
              {/* Full screen solid background to block everything */}
              <div className="popup-backdrop" />
              <div className="success-popup-overlay" onClick={() => setShowSuccessPopup(false)}>
                <div className="success-popup" onClick={(e) => e.stopPropagation()} data-testid="success-popup">
                  <button className="popup-close" onClick={() => setShowSuccessPopup(false)}>×</button>
                
                <div className="popup-header">
                  <div className="popup-checkmark">✓</div>
                  <h2>Application Received</h2>
                  <p>Thank you for your interest in joining our exclusive league.</p>
                </div>

                <div className="popup-section">
                  <h3>Connect with our President & Founder</h3>
                  <a 
                    href="https://www.linkedin.com/in/rickrockventures/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="popup-cta linkedin-cta"
                  >
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    Connect on LinkedIn
                  </a>
                </div>

                <div className="popup-section">
                  <h3>Schedule Your Private Partnership Review</h3>
                  <p className="popup-subtitle">Reserved for invited hotels, destinations and luxury travel concepts only.</p>
                  <a 
                    href="https://cal.eu/soulfulplaces/private" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="popup-cta calendar-cta"
                  >
                    Book Your Partnership Review
                  </a>
                </div>
              </div>
            </div>
            </>
          )}
        </div>

        {/* Scroll Indicator */}
        <button className="scroll-indicator" onClick={scrollToContent} aria-label="Scroll to content">
          <ChevronDown size={32} color="#e3ab19" />
        </button>
      </section>
      
      <div ref={contentRef} />
    </>
  );
};

// Apply as Hotel Section
const ApplyHotelSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    hotel_name: "",
    contact_name: "",
    email: "",
    phone: "",
    website: "",
    location: "",
    description: "",
    gdpr_consent: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.gdpr_consent) {
      setError("Bitte akzeptieren Sie die Datenschutzerklärung");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/hotel-application`, formData);
      setIsSubmitted(true);
      toast.success(response.data.message, {
        style: { background: '#141414', border: '1px solid #db2777', color: '#ffffff' }
      });
    } catch (err) {
      const errorMessage = err.response?.data?.detail || "Ein Fehler ist aufgetreten";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="apply-hotel-section" data-testid="apply-hotel-section">
      <div className="apply-hotel-bg" />
      <div className="apply-hotel-content">
        <div className="!opacity-[0%]">
          <Hotel size={48} color="#db2777" />
        </div>
        <h2 className="apply-hotel-title">Apply as a Hotel or Destination</h2>
        <p className="apply-hotel-subtitle">Be among the elite hotels & destinations with huge benefits</p>
        <p className="apply-hotel-experience">
          With over <span className="highlight">40 years experience</span> in travel & hospitality, 
          we bring innovation to the industry.
        </p>
        
        {!showForm && !isSubmitted &&
        <button
          className="apply-hotel-btn btn-luxury !rounded-[5px]"
          onClick={() => setShowForm(true)}
          data-testid="apply-hotel-btn">

            <span>Apply Now</span>
            <ArrowRight size={20} />
          </button>
        }

        {showForm && !isSubmitted &&
        <form className="hotel-application-form" onSubmit={handleSubmit} data-testid="hotel-application-form">
            <button type="button" className="close-form-btn" onClick={() => setShowForm(false)}>
              <X size={20} />
            </button>
            
            <div className="form-grid">
              <input
              type="text"
              placeholder="Hotel Name *"
              value={formData.hotel_name}
              onChange={(e) => setFormData({ ...formData, hotel_name: e.target.value })}
              required
              data-testid="hotel-name-input" />

              <input
              type="text"
              placeholder="Contact Person *"
              value={formData.contact_name}
              onChange={(e) => setFormData({ ...formData, contact_name: e.target.value })}
              required
              data-testid="contact-name-input" />

              <input
              type="email"
              placeholder="Email *"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              data-testid="hotel-email-input" />

              <input
              type="tel"
              placeholder="Phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              data-testid="hotel-phone-input" />

              <input
              type="text"
              placeholder="Website"
              value={formData.website}
              onChange={(e) => setFormData({ ...formData, website: e.target.value })}
              data-testid="hotel-website-input" />

              <input
              type="text"
              placeholder="Location *"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              required
              data-testid="hotel-location-input" />

            </div>
            
            <textarea
            placeholder="Tell us about your hotel... *"
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            required
            rows={4}
            data-testid="hotel-description-input" />

            
            <div className="gdpr-container">
              <input
              type="checkbox"
              className="gdpr-checkbox"
              checked={formData.gdpr_consent}
              onChange={(e) => setFormData({ ...formData, gdpr_consent: e.target.checked })}
              id="hotel-gdpr"
              data-testid="hotel-gdpr-check" />

              <label htmlFor="hotel-gdpr" className="gdpr-text">
                Ich stimme der <Link to="/datenschutz" className="gdpr-link">Datenschutzerklärung</Link> zu.
              </label>
            </div>

            {error && <p className="error-message">{error}</p>}
            
            <button
            type="submit"
            className="submit-application-btn btn-luxury"
            disabled={isLoading}
            data-testid="submit-hotel-application-btn">

              {isLoading ? <div className="spinner" /> : "Submit Application"}
            </button>
          </form>
        }

        {isSubmitted &&
        <div className="application-success" data-testid="application-success">
            <p>Vielen Dank für Ihre Bewerbung!</p>
            <p className="success-subtext">Wir werden uns in Kürze bei Ihnen melden.</p>
          </div>
        }
      </div>
    </section>);

};

// Footer Component
const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <img src={LOGO_URL} alt="The Soulful Traveller" className="footer-logo" />
      <p className="footer-text">© 2026 The Soulful Traveller. All rights reserved.</p>
      
      {/* LinkedIn Connect */}
      <a 
        href="https://www.linkedin.com/in/rickrockventures/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="linkedin-connect"
        data-testid="linkedin-link"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="linkedin-icon">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
        <span>Connect with Rick</span>
      </a>
      
      <div className="footer-links">
        <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
        <Link to="/impressum" className="footer-link">Impressum</Link>
        <Link to="/kontakt" className="footer-link">Kontakt</Link>
        <Link to="/admin" className="footer-link admin-link">Admin</Link>
      </div>
    </footer>);

};

// Page Component for Datenschutz, Impressum, Kontakt
const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await axios.get(`${API}/pages/${slug}`);
        setPage(response.data);
      } catch (err) {
        console.error("Error fetching page:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="page-container">
        <div className="page-loading"><div className="spinner" /></div>
      </div>);

  }

  return (
    <div className="page-container" data-testid={`page-${slug}`}>
      <header className="page-header">
        <Link to="/" className="back-home">
          <img src={LOGO_URL} alt="The Soulful Traveller" className="page-logo" />
        </Link>
      </header>
      <main className="page-content">
        <h1>{page?.title || slug}</h1>
        <div
          className="page-html-content"
          dangerouslySetInnerHTML={{ __html: page?.content || "<p>Inhalt wird geladen...</p>" }} />

      </main>
      <Footer />
    </div>);

};

// Admin Login Component
const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [sessionToken, setSessionToken] = useState("");
  const [step, setStep] = useState("login"); // login, 2fa, setup-2fa
  const [qrCode, setQrCode] = useState("");
  const [totpSecret, setTotpSecret] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      
      if (response.data.requires_2fa) {
        // 2FA is enabled - show 2FA input
        setSessionToken(response.data.session_token);
        setStep("2fa");
      } else if (response.data.token) {
        // First login - 2FA not set up yet, setup 2FA first
        localStorage.setItem("adminToken", response.data.token);
        // Don't call onLogin yet - setup 2FA first
        await setup2FA(response.data.token);
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  const setup2FA = async (token) => {
    try {
      const response = await axios.post(`${API}/admin/setup-2fa`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setQrCode(response.data.qr_code);
      setTotpSecret(response.data.secret);
      setStep("setup-2fa");
    } catch (err) {
      console.error("2FA setup failed:", err);
    }
  };

  const handleVerify2FA = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/verify-2fa`, {
        session_token: sessionToken,
        totp_code: totpCode
      });
      
      localStorage.setItem("adminToken", response.data.token);
      onLogin(response.data.token);
      toast.success("Login erfolgreich!");
    } catch (err) {
      setError(err.response?.data?.detail || "Ungültiger Code");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm2FASetup = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const token = localStorage.getItem("adminToken");
      await axios.post(`${API}/admin/confirm-2fa`, {
        session_token: totpSecret, // Sending secret
        totp_code: totpCode
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success("2FA erfolgreich aktiviert!");
      onLogin(token);
    } catch (err) {
      setError(err.response?.data?.detail || "Ungültiger Code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container" data-testid="admin-login">
      <div className="admin-login-box">
        <img src={LOGO_URL} alt="Logo" className="admin-logo" />
        
        {step === "login" && (
          <>
            <h2>Admin Login</h2>
            <form onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-username" />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password" />
              {error && <p className="error-message">{error}</p>}
              <button type="submit" disabled={loading} data-testid="admin-login-btn">
                {loading ? <div className="spinner" /> : "Login"}
              </button>
            </form>
          </>
        )}

        {step === "2fa" && (
          <>
            <h2>2-Factor Authentication</h2>
            <p className="twofa-subtitle">Enter the code from your authenticator app</p>
            <form onSubmit={handleVerify2FA}>
              <input
                type="text"
                placeholder="6-digit code"
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                maxLength={6}
                className="totp-input"
                autoFocus
                data-testid="totp-input" />
              {error && <p className="error-message">{error}</p>}
              <button type="submit" disabled={loading || totpCode.length !== 6} data-testid="verify-2fa-btn">
                {loading ? <div className="spinner" /> : "Verify"}
              </button>
            </form>
            <button className="back-btn" onClick={() => { setStep("login"); setTotpCode(""); setError(""); }}>
              ← Back to login
            </button>
          </>
        )}

        {step === "setup-2fa" && (
          <>
            <h2>Setup 2FA</h2>
            <p className="twofa-subtitle">Scan this QR code with Google Authenticator or Authy</p>
            <div className="qr-container">
              <img src={qrCode} alt="2FA QR Code" className="qr-code" />
            </div>
            <p className="secret-key">Manual key: <code>{totpSecret}</code></p>
            <form onSubmit={handleConfirm2FASetup}>
              <input
                type="text"
                placeholder="Enter 6-digit code to confirm"
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                maxLength={6}
                className="totp-input"
                data-testid="confirm-totp-input" />
              {error && <p className="error-message">{error}</p>}
              <button type="submit" disabled={loading || totpCode.length !== 6} data-testid="confirm-2fa-btn">
                {loading ? <div className="spinner" /> : "Activate 2FA"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

// Admin Dashboard Component
const AdminDashboard = () => {
  const [token, setToken] = useState(localStorage.getItem("adminToken"));
  const [pages, setPages] = useState([]);
  const [applications, setApplications] = useState([]);
  const [partnerApplications, setPartnerApplications] = useState([]);
  const [subscribersList, setSubscribersList] = useState([]);
  const [subscribersCount, setSubscribersCount] = useState(0);
  const [editingPage, setEditingPage] = useState(null);
  const [activeTab, setActiveTab] = useState("partners");
  const navigate = useNavigate();

  const defaultPages = ["datenschutz", "impressum", "kontakt"];

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  const fetchData = async () => {
    try {
      const [pagesRes, appsRes, subsCountRes, subsListRes, partnerRes] = await Promise.all([
      axios.get(`${API}/pages`),
      axios.get(`${API}/admin/hotel-applications`, {
        headers: { Authorization: `Bearer ${token}` }
      }),
      axios.get(`${API}/subscribers/count`),
      axios.get(`${API}/admin/subscribers`, {
        headers: { Authorization: `Bearer ${token}` }
      }),
      axios.get(`${API}/admin/partner-applications`, {
        headers: { Authorization: `Bearer ${token}` }
      })]
      );
      setPages(pagesRes.data);
      setApplications(appsRes.data);
      setSubscribersCount(subsCountRes.data.count);
      setSubscribersList(subsListRes.data);
      setPartnerApplications(partnerRes.data);
    } catch (err) {
      if (err.response?.status === 401) {
        handleLogout();
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    setToken(null);
  };

  const handleDeleteSubscriber = async (id) => {
    if (!window.confirm("Subscriber wirklich löschen?")) return;
    try {
      await axios.delete(`${API}/admin/subscribers/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Subscriber gelöscht");
      fetchData();
    } catch (err) {
      toast.error("Fehler beim Löschen");
    }
  };

  const handleExportCSV = async () => {
    try {
      const res = await axios.get(`${API}/admin/subscribers/export`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const blob = new Blob([res.data.csv], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `subscribers_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      toast.success(`${res.data.count} Subscribers exportiert`);
    } catch (err) {
      toast.error("Export fehlgeschlagen");
    }
  };

  const handleExportPartnersCSV = () => {
    const headers = ["Partner Type", "Company", "Website", "Contact", "Email", "Decision Maker", "DM Email", "Submitted"];
    const rows = partnerApplications.map((p) => [
      p.partner_type,
      p.company_name,
      p.website,
      p.contact_name,
      p.email,
      p.decision_maker_name || "",
      p.decision_maker_email || "",
      new Date(p.submitted_at).toLocaleDateString('de-DE')
    ]);
    const csvContent = [headers.join(","), ...rows.map(r => r.map(cell => `"${cell}"`).join(","))].join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `itb_partners_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    toast.success(`${partnerApplications.length} Partner exportiert`);
  };

  const handleSavePage = async (slug, title, content) => {
    try {
      await axios.post(`${API}/admin/pages`,
      { slug, title, content },
      { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`Seite "${slug}" gespeichert!`);
      setEditingPage(null);
      fetchData();
    } catch (err) {
      toast.error("Fehler beim Speichern");
    }
  };

  if (!token) {
    return <AdminLogin onLogin={setToken} />;
  }

  return (
    <div className="admin-dashboard" data-testid="admin-dashboard">
      <header className="admin-header">
        <Link to="/" className="admin-logo-link">
          <img src={LOGO_URL} alt="Logo" className="admin-header-logo" />
        </Link>
        <h1>Admin Dashboard</h1>
        <button onClick={handleLogout} className="logout-btn" data-testid="admin-logout">
          <LogOut size={18} /> Logout
        </button>
      </header>

      <div className="admin-stats">
        <div className="stat-card highlight" onClick={() => setActiveTab("partners")} style={{ cursor: 'pointer' }}>
          <h3>{partnerApplications.length}</h3>
          <p>ITB Partners</p>
        </div>
        <div className="stat-card" onClick={() => setActiveTab("subscribers")} style={{ cursor: 'pointer' }}>
          <h3>{subscribersCount}</h3>
          <p>Subscribers</p>
        </div>
        <div className="stat-card" onClick={() => setActiveTab("applications")} style={{ cursor: 'pointer' }}>
          <h3>{applications.length}</h3>
          <p>Hotel Applications</p>
        </div>
        <div className="stat-card" onClick={() => setActiveTab("pages")} style={{ cursor: 'pointer' }}>
          <h3>{pages.length}</h3>
          <p>Pages</p>
        </div>
      </div>

      <div className="admin-tabs">
        <button
          className={`tab-btn ${activeTab === "partners" ? "active" : ""}`}
          onClick={() => setActiveTab("partners")}>
          ITB Partner Leads
        </button>
        <button
          className={`tab-btn ${activeTab === "subscribers" ? "active" : ""}`}
          onClick={() => setActiveTab("subscribers")}>
          Newsletter Leads
        </button>
        <button
          className={`tab-btn ${activeTab === "applications" ? "active" : ""}`}
          onClick={() => setActiveTab("applications")}>
          Hotel Bewerbungen
        </button>
        <button
          className={`tab-btn ${activeTab === "pages" ? "active" : ""}`}
          onClick={() => setActiveTab("pages")}>
          Seiten bearbeiten
        </button>
      </div>

      {activeTab === "partners" &&
      <div className="admin-partners" data-testid="admin-partners-section">
          <div className="section-header-admin">
            <h2>ITB Partner Leads ({partnerApplications.length})</h2>
            <button onClick={handleExportPartnersCSV} className="export-btn" data-testid="export-partners-csv-btn">
              <Download size={16} /> Export CSV
            </button>
          </div>
          
          {partnerApplications.length === 0 ?
        <p className="no-data">Noch keine Partner-Bewerbungen</p> :

        <div className="partners-table">
              <table>
                <thead>
                  <tr>
                    <th>Typ</th>
                    <th>Unternehmen</th>
                    <th>Kontakt</th>
                    <th>Email</th>
                    <th>Decision Maker</th>
                    <th>Datum</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {partnerApplications.map((partner) =>
              <tr key={partner.id}>
                      <td><span className="partner-type-badge">{partner.partner_type}</span></td>
                      <td>
                        <div className="company-cell">
                          <strong>{partner.company_name}</strong>
                          {partner.website && <a href={partner.website} target="_blank" rel="noopener noreferrer" className="website-link">Website</a>}
                        </div>
                      </td>
                      <td>{partner.contact_name}</td>
                      <td className="email-cell">{partner.email}</td>
                      <td>
                        {partner.decision_maker_name ? (
                          <div>
                            <span>{partner.decision_maker_name}</span>
                            {partner.decision_maker_email && <small className="dm-email">{partner.decision_maker_email}</small>}
                          </div>
                        ) : <span className="no-dm">-</span>}
                      </td>
                      <td>{new Date(partner.submitted_at).toLocaleDateString('de-DE')}</td>
                      <td>
                        <span className={`status-badge ${partner.status}`}>
                          {partner.status === 'pending' ? 'Neu' : partner.status}
                        </span>
                      </td>
                    </tr>
              )}
                </tbody>
              </table>
            </div>
        }
        </div>
      }

      {activeTab === "subscribers" &&
      <div className="admin-subscribers" data-testid="admin-subscribers-section">
          <div className="section-header-admin">
            <h2>Newsletter Leads ({subscribersList.length})</h2>
            <button onClick={handleExportCSV} className="export-btn" data-testid="export-csv-btn">
              <Download size={16} /> Export CSV
            </button>
          </div>
          
          {subscribersList.length === 0 ?
        <p className="no-data">Noch keine Subscriber</p> :

        <div className="subscribers-table">
              <table>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Datum</th>
                    <th>GDPR</th>
                    <th>Status</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {subscribersList.map((sub) =>
              <tr key={sub.id}>
                      <td className="email-cell">{sub.email}</td>
                      <td>{new Date(sub.subscribed_at).toLocaleDateString('de-DE')}</td>
                      <td>
                        <span className={`gdpr-badge ${sub.gdpr_consent ? 'yes' : 'no'}`}>
                          {sub.gdpr_consent ? '✓' : '✗'}
                        </span>
                      </td>
                      <td>
                        <span className={`status-badge ${sub.is_active ? 'active' : 'inactive'}`}>
                          {sub.is_active ? 'Aktiv' : 'Inaktiv'}
                        </span>
                      </td>
                      <td>
                        <button
                    onClick={() => handleDeleteSubscriber(sub.id)}
                    className="delete-btn-small"
                    title="Löschen">

                          <Trash2 size={14} />
                        </button>
                      </td>
                    </tr>
              )}
                </tbody>
              </table>
            </div>
        }
        </div>
      }

      {activeTab === "pages" &&
      <div className="admin-pages" data-testid="admin-pages-section">
          <h2>Seiten verwalten</h2>
          <div className="pages-grid">
            {defaultPages.map((slug) => {
            const existingPage = pages.find((p) => p.slug === slug);
            return (
              <div key={slug} className="page-card">
                  <h3>{slug.charAt(0).toUpperCase() + slug.slice(1)}</h3>
                  <p>{existingPage ? "Bearbeitet" : "Standard"}</p>
                  <button
                  onClick={() => setEditingPage({
                    slug,
                    title: existingPage?.title || slug.charAt(0).toUpperCase() + slug.slice(1),
                    content: existingPage?.content || ""
                  })}
                  className="edit-page-btn"
                  data-testid={`edit-page-${slug}`}>

                    <Edit size={16} /> Bearbeiten
                  </button>
                </div>);

          })}
          </div>

          {editingPage &&
        <div className="page-editor-modal">
              <div className="page-editor">
                <div className="editor-header">
                  <h3>Seite bearbeiten: {editingPage.slug}</h3>
                  <button onClick={() => setEditingPage(null)} className="close-editor">
                    <X size={20} />
                  </button>
                </div>
                <input
              type="text"
              value={editingPage.title}
              onChange={(e) => setEditingPage({ ...editingPage, title: e.target.value })}
              placeholder="Seitentitel"
              className="editor-title-input"
              data-testid="page-title-input" />

                <textarea
              value={editingPage.content}
              onChange={(e) => setEditingPage({ ...editingPage, content: e.target.value })}
              placeholder="HTML Inhalt der Seite..."
              rows={15}
              className="editor-content-input"
              data-testid="page-content-input" />

                <div className="editor-actions">
                  <button
                onClick={() => handleSavePage(editingPage.slug, editingPage.title, editingPage.content)}
                className="save-page-btn"
                data-testid="save-page-btn">

                    <Save size={16} /> Speichern
                  </button>
                </div>
              </div>
            </div>
        }
        </div>
      }

      {activeTab === "applications" &&
      <div className="admin-applications" data-testid="admin-applications-section">
          <h2>Hotel Bewerbungen</h2>
          {applications.length === 0 ?
        <p className="no-applications">Noch keine Bewerbungen</p> :

        <div className="applications-list">
              {applications.map((app) =>
          <div key={app.id} className="application-card">
                  <div className="app-header">
                    <h3>{app.hotel_name}</h3>
                    <span className={`status-badge ${app.status}`}>{app.status}</span>
                  </div>
                  <p><strong>Kontakt:</strong> {app.contact_name}</p>
                  <p><strong>Email:</strong> {app.email}</p>
                  <p><strong>Location:</strong> {app.location}</p>
                  {app.phone && <p><strong>Phone:</strong> {app.phone}</p>}
                  {app.website && <p><strong>Website:</strong> <a href={app.website} target="_blank" rel="noopener noreferrer">{app.website}</a></p>}
                  <p className="app-description">{app.description}</p>
                  <p className="app-date">Eingereicht: {new Date(app.submitted_at).toLocaleDateString('de-DE')}</p>
                </div>
          )}
            </div>
        }
        </div>
      }
    </div>);

};

// Home Page Component
const HomePage = () => {
  const [previewItem, setPreviewItem] = useState(null);
  const [showNetflixInfo, setShowNetflixInfo] = useState(true);
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);

  const handleShowPreview = (item) => {
    setPreviewItem(item);
    setShowNetflixInfo(false); // Start collapsed on mobile for clean look
  };

  const handleClosePreview = () => {
    setPreviewItem(null);
    setShowSubscribePopup(false);
  };

  return (
    <>
      <HeroSection />
      {contentSections.map((section) =>
      <ContentSection key={section.id} section={section} onShowPreview={handleShowPreview} />
      )}
      <Footer />

      {/* Netflix-Style Video Preview Popup for Amangiri */}
      {previewItem && (
        <div className="netflix-preview-overlay" data-testid="netflix-preview">
          {/* Background Video with Fallback Image */}
          <div className="netflix-video-bg">
            <div className="netflix-bg-image" style={{ backgroundImage: `url(${previewItem.image})` }} />
            <iframe
              src="https://www.youtube.com/embed/CwqFGjAi3sU?autoplay=1&mute=1&loop=1&playlist=CwqFGjAi3sU&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&start=10&fs=0&playsinline=1&enablejsapi=1"
              title="Amangiri Background"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
            <div className="netflix-video-gradient" />
            <div className="netflix-video-cover" />
          </div>

          {/* Text Logo Overlay - Top Right on Video */}
          <img 
            src="https://customer-assets.emergentagent.com/job_7ccccdb5-1c1b-4dfb-bdc2-42a7e485fece/artifacts/o2jk3kgd_11.png" 
            alt="Soulful Places" 
            className="netflix-text-logo"
          />

          {/* Top Navigation - Back Button Only */}
          <div className="netflix-top-nav">
            <button className="netflix-back-btn" onClick={handleClosePreview}>
              <ArrowLeft size={20} />
            </button>
            <button className="netflix-heart-btn">
              <Heart size={20} />
            </button>
          </div>

          {/* Content Section - Collapsible */}
          <div className={`netflix-content ${showNetflixInfo ? 'expanded' : 'collapsed'}`}>
            {/* Toggle Button */}
            <button 
              className="netflix-info-toggle" 
              onClick={() => setShowNetflixInfo(!showNetflixInfo)}
            >
              <ChevronDown size={20} className={showNetflixInfo ? 'rotated' : ''} />
              <span>{showNetflixInfo ? '' : 'Info'}</span>
            </button>

            {/* Collapsible Info Section */}
            <div className="netflix-info-section">
              {/* Category Tags */}
              <div className="netflix-category-tags">
                <span className="netflix-tag featured">FEATURED</span>
                <span className="netflix-tag category">LONGEVITY HOTELS</span>
                <span className="netflix-tag category">DESERT SANCTUARY</span>
              </div>

              {/* Title */}
              <h1 className="netflix-title">
                {previewItem.title}
              </h1>

              {/* Location */}
              <div className="netflix-location">
                <MapPin size={14} />
                <span>{previewItem.location}</span>
              </div>

              {/* Description */}
              <p className="netflix-description">
                Nestled in the heart of Canyon Point, Amangiri offers a transformative experience where ancient landscapes meet modern wellness.
              </p>

              {/* Hashtags */}
              <div className="netflix-hashtags">
                {previewItem.tags.map((tag, i) => (
                  <span key={i} className="netflix-hashtag">#{tag}</span>
                ))}
                <span className="netflix-hashtag">#Luxury</span>
              </div>
            </div>

            {/* Action Buttons - Always Visible but Grayed */}
            <div className="netflix-actions">
              <button className="netflix-play-btn" data-testid="netflix-play-btn">
                <Play size={16} fill="#000" />
                <span>Play</span>
              </button>
              <button className="netflix-podcast-btn disabled">
                <Headphones size={14} />
                <span>Podcast DE</span>
              </button>
              <button className="netflix-podcast-btn disabled">
                <Headphones size={14} />
                <span>Podcast EN</span>
              </button>
              <div className="netflix-rating">
                <Star size={12} fill="#e3ab19" color="#e3ab19" />
                <span>10/10</span>
              </div>
            </div>

            {/* Secondary Actions */}
            <div className="netflix-secondary-actions">
              <button className="netflix-icon-btn disabled">
                <Share2 size={14} />
              </button>
              <button className="netflix-icon-btn disabled">
                <MessageCircle size={14} />
              </button>
              <button className="netflix-book-btn disabled" data-testid="netflix-book-btn">
                <Globe size={14} />
                <span>Book</span>
              </button>
            </div>

            {/* Episodes Section */}
            <div className="netflix-episodes" data-testid="netflix-episodes">
              <h3 className="episodes-title">Episodes</h3>
              <div className="episodes-list">
                {/* Episode 1 - Playable */}
                <div className="episode-card playable" data-testid="episode-1">
                  <div className="episode-thumb">
                    <img src={previewItem.image} alt="Episode 1" />
                    <div className="episode-play">
                      <Play size={20} fill="#fff" />
                    </div>
                    <span className="episode-duration">12:34</span>
                  </div>
                  <div className="episode-info">
                    <span className="episode-number">E1</span>
                    <span className="episode-name">The Arrival</span>
                  </div>
                </div>

                {/* Episode 2-5 - Locked with onClick */}
                {[
                  { num: 2, name: 'Wellness Journey' },
                  { num: 3, name: 'Desert Dreams' },
                  { num: 4, name: 'Canyon Secrets' },
                  { num: 5, name: 'Transformation' }
                ].map(ep => (
                  <div 
                    key={ep.num}
                    className="episode-card locked" 
                    data-testid={`episode-${ep.num}`}
                    onClick={() => setShowSubscribePopup(true)}
                  >
                    <div className="episode-thumb">
                      <img src={previewItem.image} alt={`Episode ${ep.num}`} />
                      <div className="episode-lock">
                        <Lock size={16} />
                      </div>
                    </div>
                    <div className="episode-info">
                      <span className="episode-number">E{ep.num}</span>
                      <span className="episode-name">{ep.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Subscribe Popup */}
          {showSubscribePopup && (
            <div className="subscribe-popup-overlay" onClick={() => setShowSubscribePopup(false)}>
              <div className="subscribe-popup" onClick={e => e.stopPropagation()}>
                <button className="subscribe-popup-close" onClick={() => setShowSubscribePopup(false)}>
                  <X size={20} />
                </button>
                <Lock size={32} className="subscribe-popup-icon" />
                <h2>Subscribe Now</h2>
                <p>to be among the first</p>
                <button className="subscribe-popup-btn" onClick={() => setShowSubscribePopup(false)}>
                  Coming Soon
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>);

};

// Main App Component
function App() {
  return (
    <div className="App" data-testid="app-container">
      <Toaster position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/:slug" element={<PageView />} />
        </Routes>
      </BrowserRouter>
    </div>);

}

export default App;